enum MechanicPausedStatus {
  NOT_APPLICABLE = 10,
  IS_NOT_PAUSED = 20,
  IS_PAUSED = 30,
}

export default MechanicPausedStatus;
